import React from 'react';
import dayjs from 'dayjs';

import './print.css';
import requireAuth from '~components/hocs/requireAuth';
import { PrintableExportShell } from '~components/PrintableLayout';
import DashboardV3Page from '~features/dashboard-v3';

function DashboardExport() {
  React.useEffect(() => {
    document.title = `Prerender - Dashboard export PDF ${dayjs().format('YYYY-MM-DD')}`;
  }, []);

  return (
    <PrintableExportShell>
      <DashboardV3Page print />
    </PrintableExportShell>
  );
}

export default requireAuth(DashboardExport);
